import React from 'react';
import Immutable from 'immutable';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import { CoreLink } from '@uncinc/react-drupal-core';

import { WysiwygField } from '../../../components';

import './style.scss';

const ParagraphLinkList = ({ id, entity }) => {
  const title = entity.getIn(['field_title', 0, 'value'], '');
  const body = entity.getIn(['field_body', 0, 'processed'], '');

  return (
    <Container id={id} className="Paragraph ParagraphLinkList">
      <div className="row">
        <div className="ParagraphLinkList__inner col-12">
          {title && (
            <h2 className="ParagraphLinkList__title">{title}</h2>
          )}
          {body &&
            <WysiwygField
              property="schema:LinkList"
              className="ParagraphLinkList__body"
              html={body}
            />}
          <div className="ParagraphLinkList__items">
            {entity.getIn(['field_link_list_items'], Immutable.List()).map((item, index) => {
              const itemEntity = item.get('entity');
              const title = itemEntity.getIn(['field_title', 0, 'value']);
              const body = itemEntity.getIn(['field_body', 0, 'processed']);
              const linkUrl = itemEntity.getIn(['field_link', 0, 'alias'], itemEntity.getIn(['field_link', 0, 'uri']));
              const linkTitle = itemEntity.getIn(['field_link', 0, 'title']);
              const linkTarget = itemEntity.getIn(['field_link', 0, 'options', 'attributes', 'target'], '_self');

              return (
                <div key={index} className="ParagraphLinkList__item">
                  <div className="ParagraphLinkList__item-index">
                    <div>{index + 1}</div>
                  </div>
                  {title && (
                    <h4 className="ParagraphLinkList__item-title">{title}</h4>
                  )}
                  <WysiwygField
                    property="schema:LinkListItem"
                    className="ParagraphLinkList__item-body"
                    html={body}
                  />
                  {linkUrl && linkTitle && (
                    <CoreLink
                      className="ParagraphLinkList__item-link"
                      href={linkUrl}
                      target={linkTarget}
                      primary={false}
                    >
                      {linkTitle}<div className="icon icon-arrow-right icon-variant-2" />
                    </CoreLink>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphLinkList;
